import React, { useState, useEffect } from 'react';
import { TextButton } from '../Button';
import Dialog from '../Dialog/Dialog';
import Input from '../Input/Input';
import TextArea from '../TextArea/TextArea';
import './ReviewDialog.css';
// @ts-ignore
import addIcon from '../../image-assets/icon.add.svg';

interface ReviewDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (title: string, description: string) => void;
  isLoading?: boolean;
  initialTitle?: string;
  initialDescription?: string;
  selectedKeys?: string[];
}

const ReviewDialog: React.FC<ReviewDialogProps> = ({
  isOpen,
  onClose,
  onSave,
  isLoading = false,
  initialTitle = '',
  initialDescription = '',
  selectedKeys = []
}) => {
  const [title, setTitle] = useState(initialTitle);
  const [description, setDescription] = useState(initialDescription);
  const [titleError, setTitleError] = useState<string | undefined>();

  // Reset form state when dialog opens
  useEffect(() => {
    if (isOpen) {
      setTitle(initialTitle);
      setDescription(initialDescription);
      setTitleError(undefined);
    }
  }, [isOpen, initialTitle, initialDescription]);

  const handleSave = () => {
    if (!title.trim()) {
      setTitleError('Title is required');
      return;
    }
    setTitleError(undefined);
    onSave(title.trim(), description.trim());
  };

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title={`New review with ${selectedKeys.length} ${selectedKeys.length === 1 ? 'key' : 'keys'}`}
      showCloseButton={false}
      headerActions={
        <>
          <TextButton 
            variant="secondary" 
            size="small"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </TextButton>
          <TextButton
            variant="primary"
            size="small"
            onClick={handleSave}
            isLoading={isLoading}
          >
            Add
          </TextButton>
        </>
      }
    >
      <div className="review-dialog-content">
        <Input
          label="Title"
          value={title}
          onChange={(e) => {
            setTitle(e.target.value);
            if (titleError) setTitleError(undefined);
          }}
          placeholder="Enter review title"
          disabled={isLoading}
          error={titleError}
          required
        />
        <TextArea
          label="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Enter review description"
          rows={4}
          disabled={isLoading}
        />
      </div>
    </Dialog>
  );
};

export default ReviewDialog; 